import get from 'lodash.get';
import { localStorage } from 'dibs-browser-storage';
import { PAGE_TYPE } from 'dibs-constants/exports/pageTypes';

import { PRIVACY_POLICY_CHANGE_LOCAL_STORAGE_KEY } from './privacyPolicyConstants';
import { getUserSessionCountryCode } from 'dibs-regional-info/exports/regionalInfoHelpers';
import isPageType from '../../../utils/isPageType';

const hasSeenPrivacyPolicyChangeNotice = () =>
    localStorage.getItem(PRIVACY_POLICY_CHANGE_LOCAL_STORAGE_KEY);

export const blockedPageTypes = [PAGE_TYPE.CHECKOUT, PAGE_TYPE.CHECKOUT_CONFIRMATION];

export const isAllowedPageType = () => !isPageType(blockedPageTypes);

export const initialRule = userId => !!userId && !hasSeenPrivacyPolicyChangeNotice();

export const viewerRule = viewer => {
    if (!viewer) {
        return false;
    }

    const userCreatedDate = get(viewer, 'user.createdDate');
    const userWasCreatedBeforePolicyChange =
        userCreatedDate && new Date(userCreatedDate) < new Date('1/30/19');
    const countryCode = getUserSessionCountryCode() || get(viewer, 'regionalInfo[0].countryCode');
    const isUS = countryCode === 'US';
    const doNotShowPrivacyPolicyAlerts = true;

    return !doNotShowPrivacyPolicyAlerts && userWasCreatedBeforePolicyChange && isUS;
};
